import React, { createContext, useRef, useState } from "react";
import GTM from "@utils/GTM";
const defaultState = {};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
  const headerRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);

  const openModal = (modalType) => {
    GTM.handleModal(true, modalType);
    setShowModal(true);
    setModalType(modalType);
  };

  const closeModal = () => {
    GTM.handleModal(false, modalType);
    setShowModal(false);
    setModalType(null);
  };

  const store = {
    headerRef,
    showModal,
    modalType,
    setShowModal,
    setModalType,
    openModal,
    closeModal,
  };

  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
